import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbAccordionModule, NgbDatepickerModule, NgbDropdownModule, NgbModule, NgbNavModule, NgbTimepickerModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {AccordionAnchorDirective} from './accordion/accordionanchor.directive';
import {AccordionLinkDirective} from './accordion/accordionlink.directive';
import {AccordionDirective} from './accordion/accordion.directive';
import {HttpClientModule} from '@angular/common/http';
import {TitleComponent} from '../layout/admin/title/title.component';
import {CardComponent} from './card/card.component';
import {CardToggleDirective} from './card/card-toggle.directive';
import {ModalAnimationComponent} from './modal-animation/modal-animation.component';
import {SpinnerComponent} from './spinner/spinner.component';
import {DataFilterPipe} from './elements/data-filter.pipe';
import {GridComponentComponent} from './components/grid-component/grid-component.component';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {OptionComponent} from './option/option.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {FormsModule} from '@angular/forms';
import {SummaryBoxComponent} from './summary-box/summary-box.component';
import {CustomCurrencyPipe} from '../pipe/custom-currency.pipe';
import {SummaryBoxOptionComponent} from './summary-box-option/summary-box-option.component';
import {AutofocusDirective} from './directives/autofocus.directive';
import {CopyClipboardDirective} from './directives/copy-clipboard.directive';
import {FileUploaderComponent} from './components/file-uploader/file-uploader.component';
import {FileUploadModule} from 'ng2-file-upload';
import {EditorComponent} from './components/editor/editor.component';
import {QuillModule} from 'ngx-quill';
import {ModalBasicComponent} from './modal-basic/modal-basic.component';
import {EditorFormlyComponent} from './components/editor-formly/editor-formly.component';
import { FileUploaderFormlyComponent } from './components/file-uploader-formly/file-uploader-formly.component';
import {StrengthValidatorDirective} from './directives/strength.directive';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { CookieService } from 'ngx-cookie-service';
import {TreeviewComponent} from '@paymate-software/ngx-treeview';
import { PartsTableComponent } from './components/parts-table/parts-table.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    NgbNavModule,
    NgbDatepickerModule,
    NgbTooltipModule,
    NgbAccordionModule,
    NgbTimepickerModule,
    NgbDropdownModule,
    HttpClientModule,
    FormsModule,
    NgSelectModule,
    FileUploadModule,
    QuillModule,
    NgbModule,
    TreeviewComponent
  ],
  exports: [
    NgbNavModule,
    NgbDatepickerModule,
    NgbTooltipModule,
    NgbAccordionModule,
    NgbTimepickerModule,
    NgbDropdownModule,
    TranslateModule,
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    CardToggleDirective,
    HttpClientModule,
    TitleComponent,
    CardComponent,
    OptionComponent,
    ModalAnimationComponent,
    SpinnerComponent,
    DataFilterPipe,
    SummaryBoxComponent,
    CustomCurrencyPipe,
    SummaryBoxOptionComponent,
    AutofocusDirective,
    ModalBasicComponent,
    FileUploaderComponent,
    FileUploaderFormlyComponent,
    EditorComponent,
    EditorFormlyComponent,
    CopyClipboardDirective,
    StrengthValidatorDirective,
    ClickOutsideDirective,
    TreeviewComponent,
    PartsTableComponent
  ],
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    CardToggleDirective,
    TitleComponent,
    CardComponent,
    OptionComponent,
    ModalAnimationComponent,
    SpinnerComponent,
    DataFilterPipe,
    GridComponentComponent,
    OptionComponent,
    SummaryBoxComponent,
    CustomCurrencyPipe,
    SummaryBoxOptionComponent,
    AutofocusDirective,
    ModalBasicComponent,
    FileUploaderComponent,
    EditorComponent,
    EditorFormlyComponent,
    FileUploaderFormlyComponent,
    CopyClipboardDirective,
    StrengthValidatorDirective,
    ClickOutsideDirective,
    PartsTableComponent
  ],
  schemas: [NO_ERRORS_SCHEMA],
  providers: [
    CookieService,
    TranslateService
  ]
})
export class SharedModule {
}
